import React from "react";

import moment from "moment/moment";
import { NavLink } from "react-router-dom";
import ReactHtmlParser from "react-html-parser";

import LoadingBox from "./LoadingBox";
import MessageBox from "./MessageBox";

import { useNotices } from "../features/useNotices";
import Spinner from "../UI/Spinner";

const Notice = ({ noticeConfig }) => {
  // const { data, loading, error } = useFetch(
  //   noticeConfig.home ? "notice" : "allNotice"
  // );

  const { notices: data, isLoading, error } = useNotices(noticeConfig);

  if (isLoading) return <Spinner />;
  if (error) return <MessageBox>{error.message}</MessageBox>;

  return (
    <div className="card noticeCard">
      <ul className="list-group list-group-flush">
        {noticeConfig.home &&
          data
            .slice(0, 6)
            .map((notice, index) => <NoticeList notice={notice} key={index} />)}

        {noticeConfig.faculty &&
          data
            .slice(0, 6)
            .map((notice, index) => <NoticeList notice={notice} key={index} />)}
        {noticeConfig.department &&
          data
            .slice(0, 6)
            .map((notice, index) => <NoticeList notice={notice} key={index} />)}
      </ul>

      <NavLink exact to="/noticePage">
        View All
      </NavLink>
    </div>
  );
};

export default Notice;

function NoticeList({ notice }) {
  return (
    <li className="list-group-item" key={notice.id}>
      <p className="card-title heading6 text-left">
        <NavLink exact to={"/notice/" + notice.id}>
          {ReactHtmlParser(notice.headline)}
        </NavLink>
      </p>
      <h4 className="card-subtitle mb-2 text-muted text-left">
        Publish Date: {moment(notice.noticeDate, "YYYY/MM/DD").format("LL")}
      </h4>
    </li>
  );
}

/*{noticeConfig.home &&
          data
            ?.filter((item) => item.is_all === true)
            .slice(0, 8)
            .map((notice, index) => <NoticeList notice={notice} key={index} />)}

        {noticeConfig.faculty &&
          data
            ?.filter((item) =>
              item.faculty.some((i) => i.collegecode === noticeConfig.faculty)
            )
            .slice(0, 8)
            .map((notice, index) => <NoticeList notice={notice} key={index} />)}
        {noticeConfig.department &&
          data
            ?.filter((item) =>
              item.department.some((i) => i.depid === noticeConfig.department)
            )
            .slice(0, 8)
            .map((notice, index) => <NoticeList notice={notice} key={index} />)}

  */
